module.exports = __webpack_public_path__ + "img/图片5.dd302206.png";